import React from "react";
import { RadioGroup } from "@mui/material";

const DSRadioGroup = (props: React.ComponentProps<typeof RadioGroup>) => {
  return <RadioGroup {...props} />;
};

export default DSRadioGroup;
